import { GeoLocationEntity } from '@smatchy/sdk';

export class LoadAllNextEventsOfMyGroupsAction {
  static readonly type = '[EventsOfMyGroups] LoadAllNextEventsOfMyGroupsAction';

  constructor(public payload: { groupIds: string[]; page?: number }) {}
}

export class FindNextEventsOfMyGroupsAction {
  static readonly type = '[EventsOfMyGroups] FindNextEventsOfMyGroupsAction';

  /**
   * `location?` because there is not always one: the explore screen passes
   * nothing when nobody has shared a position, which it has always done -- the
   * field was simply typed as though it could not happen.
   *
   * THE GENERATED DTO DISAGREES, and it is the one that is wrong. It marks
   * `location` required because the API's DTO marks its fields with `@Allow()`
   * and never says optional, so the OpenAPI document reports it required. The
   * query behind that route declares `location?` and its own spec executes
   * without one: no location means no distance filter. The single assertion to
   * the generated body sits in the state beside a pointer to this note, and the
   * real fix is one `@IsOptional()` on the API's DTO, which belongs to the API.
   */
  constructor(public payload: { groupIds: string[]; location?: GeoLocationEntity }) {}
}
